import { render, staticRenderFns } from "./drawerWuliuxinxi.vue?vue&type=template&id=83121e92&scoped=true&"
import script from "./drawerWuliuxinxi.vue?vue&type=script&lang=js&"
export * from "./drawerWuliuxinxi.vue?vue&type=script&lang=js&"
import style0 from "./drawerWuliuxinxi.vue?vue&type=style&index=0&id=83121e92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83121e92",
  null
  
)

export default component.exports